export const AppRoutes = {
    Login: "/login",
    Redirect: "/redirect",
    Home: "/",
    OrderList: "/order-list",
    ApplicationList: "/application-list",
    Credits: "/credits",
    Order: "/order/:orderId",
    UserActivityLog: '/user-activity-log',
    LandingPage: "/landing-page",
    TenantList: "/tenant-list",
    UserList: "/user-list",
    Registration: "/registration",
    Subscriptions: "/subscriptions/product/:productReference",
    Register: "/register",
    Consumptions: "/consumptions/product/:productReference",
    SingleSignOn: "/single-sign-on",
    ActivationRenewal: "/activation-renewal",
    Public: "/public",
    StoneCopilotShield: "/public/stone-copilot/shield",
    StoneCopilotFrequentlyAskedQuestions: "/public/stone-copilot/frequently-asked-questions",
}
